/**
 *
 * Layout
 *
 */
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import Loader from '~/comps/Loader'
import { DEVICE_ID } from '~/lib/constants'
import { setGlobalNavigate } from '~/lib/navigate'

const Root = () => {
	const { isAuthenticated, isLoading, logout } = useAuth0()
	const navigate = useNavigate()

	// Initialize global navigate function for actions
	useEffect(() => {
		setGlobalNavigate(navigate)
	}, [navigate])

	// Force logout if query param is present (for new user registration flow)
	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		if (params.has('nu') && isAuthenticated && !isLoading) {
			// Remove the param before logout to prevent redirect loop
			params.delete('nu')
			const cleanUrl = params.toString()
				? `${window.location.pathname}?${params.toString()}`
				: window.location.pathname

			logout({
				logoutParams: {
					returnTo: `${window.location.origin}${cleanUrl}`,
					federated: true, // Also clear Auth0's SSO session
				},
			})
		}
	}, [isAuthenticated, isLoading, logout])

	useEffect(() => {
		// Don't replace URL if 'nu' param is present (logout will happen)
		const params = new URLSearchParams(window.location.search)
		if (isAuthenticated && !DEVICE_ID && !params.has('nu')) {
			const name = Math.random().toString(36).substring(2, 10)
			window.history.replaceState({}, '', `?name=${name}`)
		}
	}, [isAuthenticated])

	if (isLoading) return <Loader />
	return <Outlet />
}

export default Root
